// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__fX75u{
  align-items: center;
  display: flex;
  justify-content: center;
}

.styles_item__5AkmX{
  background: white;
  border-radius: 10px;
  box-shadow: 2px 2px 5px black;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 2rem;
}
`, "",{"version":3,"sources":["webpack://./src/pages/ExportXml/styles.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,aAAa;AACf","sourcesContent":[".container{\n  align-items: center;\n  display: flex;\n  justify-content: center;\n}\n\n.item{\n  background: white;\n  border-radius: 10px;\n  box-shadow: 2px 2px 5px black;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding: 2rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__fX75u`,
	"item": `styles_item__5AkmX`
};
export default ___CSS_LOADER_EXPORT___;
